import { http } from 'services';

export const List = ({ params }) => http.request.post('/v1/gov-function/open-collegial-organization/pageable', {
    per_page: params.perPage,
    page: params.page,
    sort: params.sort,
    search: params.filter
  });